import React,{Component} from 'react';
import Head from './Head'
import Foot from './Foot'
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';
import { withStyles, MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import Label from './Label'
import { getJSON } from 'jquery'
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Divider from 'material-ui/Divider';

import ExpansionPanel, {
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';



class WriteBlog extends Component{
constructor(props){
    super(props);
    this.state={
        load:false,
        editorState: EditorState.createEmpty(),
        submitError:false,
        title:'',
        id:'',
        novelArray:[]
    }

}


    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: event.target.value});
        console.log(this.state)
    }

    handleSubmit(){
        const {title,id}=this.state;
        if (title!=''&&id!='') {
            this.setState({
                load: true
            })
            const main = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));

            const form = new FormData();
            form.append('title', title);

            form.append('main', main);
            form.append('id', id);
            const url = 'http://123.207.90.121:8080/newBlog/api/addContext';
            return fetch(url, {
                body:form,
                method: 'POST'
            })
                .then(function(response) {
                    return response.json();
                })
                .then(response => {
                    console.log("sadsdasad"+response)
                    return
                    true
                }).then((flash) =>  this.props.handleNovelRoute())
                .catch(error => console.error('Error:', error))

        }
    }
    handleSubmitError(){
        this.setState({SubmitError:!this.state.SubmitError})
        this.setState({
            load:false
        })

    }



    componentWillMount(){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/getNovels').then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.setState({
                    novelArray:data
                })
                console.log("加载novel成功"+data.length)
            }else {
                this.handleLoginError();
                console.log("加载novel失败")
            }
            return true;
        },error=> {
        }).then(flag=>{
            this.setState({
                load:false
            })
        })
    }



    onEditorStateChange=(editorState)=> {
        this.setState({
            editorState:editorState
        });
    };


    render(){

        const theme = createMuiTheme({
            palette: {
                primary: green,
            },
        });


        return(
            <div id="cc" style={{height:'100%',overflow: 'auto'}}>
                <Head src='image/novelHeader.jpg' title='Write Novel Chapter' sentence='Red sand flows out,Sweet mouthThe, sky is painted in Lunacia' />
                <div style={{backgroundImage:'url(\'image/pageBackground.jpg\')',backgroundColor:'white',backgroundSize:'cover',padding:'50px 5% 50px',
                    backgroundPositionX:'center',
                    backgroundPositionY: 'top',
                    boxShadow: '0px 10px 10px 10px  #888888 inset',minHeight:'100%'
                }}>


                    <Grid  container spacing={24}style={{display:'flex',
                        flexDirection:'row-reverse',
                        flexWrap:'warp',
                        justifyContent:'flex-start'}}>


                        <Grid item  sm={2} />





                        <Grid item xs={12} sm={12} md={8}>

                                <Paper style={{height:'100%',width:'100%'}}>



                                    <MuiThemeProvider theme={theme}>
                                        <div style={{textAlign:'Center',overflow:'hidden'}}>
                                            <h1 style={{color:'black'}}><b>WRITE NOVEL CHAPTER FORM</b></h1>
                                        </div>
                                        <Grid container spacing={24} >
                                        <Grid item xs={12} sm={12} md={6} style={{textAlign:'center'}}>
                                                <FormControl>
                                                    <InputLabel htmlFor="title" >TITLE</InputLabel>
                                                    <Input type='text'
                                                           id="title"  onChange={this.handleChange.bind(this)} name="title"
                                                           startAdornment={
                                                               <InputAdornment position="start">
                                                                   <i className="material-icons">subtitles</i>
                                                               </InputAdornment>
                                                           }
                                                    />
                                                </FormControl>
                                        </Grid>




                                        <Grid item xs={12} sm={12} md={6} style={{textAlign:'center'}}>
                                            <FormControl >
                                                <InputLabel htmlFor="type">Novel</InputLabel>
                                                <Select
                                                    value={this.state.id}
                                                    onChange={this.handleChange.bind(this)}
                                                    inputProps={{
                                                        name: 'id',
                                                        id: 'id',
                                                    }}
                                                >
                                                    {this.state.novelArray.map((novel)=>{
                                                        return(
                                                            <MenuItem key={novel.novelId} value={novel.novelId}>{novel.novelTitle}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>







                                            <Grid item xs={12} sm={12} md={12} style={{textAlign:'center'}}>
                                                <Grid container style={{textAlign:'center'}}>
                                                    <Grid item  sm={1} />
                                                    <Grid item xs={12} sm={12} md={10}  style={{textAlign:'center'}}>
                                            <div>
                                                <Editor
                                                    toolbar={{

                                                        image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                                                    }}
                                                    editorState={this.state.editorState}
                                                    wrapperClassName="demo-wrapper"
                                                    editorClassName="demo-editor"
                                                    onEditorStateChange={this.onEditorStateChange}
                                                        localization={{
                                                            locale: 'zh',
                                                        }}
                                                />



                                            </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>


                                            <Grid item xs={12} sm={12} md={12} style={{textAlign:'center',marginTop:'20px',marginBottom:'20px'}}>

                                                <FormControl>

                                                    {this.state.load?
                                                        <Button size="large" style={{backgroundColor:'#ac2d27'}}  >
                                                            Loading
                                                        </Button>
                                                        :
                                                        <Button size="large" style={{backgroundColor:'#5ac73e'}} onClick={this.handleSubmit.bind(this)} >
                                                            SUBMIT
                                                        </Button>
                                                    }

                                                </FormControl>

                                            </Grid>




                                        </Grid>
                                    </MuiThemeProvider>
                                </Paper>




                        </Grid>




                    </Grid>




                </div>
                <Foot src='image/novelFooter.jpg'  sentence='There is no escape, my dear' info='© 2018 By Kayer'  />
            </div>
        )
    }

        uploadImageCallBack(file) {

            const form = new FormData();
            form.append('image', file);
            const url = 'http://123.207.90.121:8080/newBlog/files/upload';
            return fetch(url, {
                body:form,
                method: 'POST'
            })
                .then(function(response) {
                    return response.json();
                })
               .then(response => {
                                   console.log("sadsdasad"+response)
                    return {
                        data: {
                            link:response.data,
                        }
                    }
                })
                .catch(error => console.error('Error:', error))




    }



}
export default WriteBlog;


// WEBPACK FOOTER //
// ./src/Compent/page/WriteNovelContext.js